export default[
    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/settings.vue'),
        redirect:'/settings/pdetails',
        children: [
             {
               path: 'pdetails',
               name: 'pdetails',
               component: () => import('@/views/settings/pdetails.vue'),
             },
             {
                path: 'password',
                name: 'password',
                component: () => import('@/views/settings/password.vue'),
              },
              {
                path: 'paypassword',
                name: 'paypassword',
                component: () => import('@/views/settings/paypassword.vue'),
              },
        ]
    },
    
]